import React, { useMemo } from 'react';
import FormSection from '../../../shared/FormSection';
import SystemDocumentsTable from '../../../shared/SystemDocumentsTable';

const BUSINESS_CASE_DOCUMENT_TYPE = 'BUSINESS_CASE';

const WizardStepComplianceGovernance = ({
  values,
  errors,
  onLookupChange,
}) => {
  const allDocuments = values.documents ?? [];
  const complianceDocuments = useMemo(
    () => allDocuments.filter((d) => d.documentType !== BUSINESS_CASE_DOCUMENT_TYPE),
    [allDocuments]
  );
  const businessCaseDocuments = useMemo(
    () => allDocuments.filter((d) => d.documentType === BUSINESS_CASE_DOCUMENT_TYPE),
    [allDocuments]
  );

  return (
    <FormSection>
      <SystemDocumentsTable
        rows={complianceDocuments}
        onChange={(docs) => onLookupChange('documents', [...businessCaseDocuments, ...(docs || [])])}
        error={errors.documents}
      />
    </FormSection>
  );
};

export default WizardStepComplianceGovernance;
